import axios from 'axios';

declare let core_object: any;

export default class moreComments{

    protected elBtn: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_get_comments: string;

    /**
     * Constructor
     * @param elBtn
     */
    constructor(
        elBtn: string
    ){
        
        this.elBtn = elBtn;
        this.url_api_get_comments = core_object.rest_urls.comments_load_more;

    }

    // Load comments
    loadComments(){
        
        const _that = this;

        const btns = document.querySelectorAll(this.elBtn);

        btns.forEach((btnEl) => {
            
            const btn = document.getElementById(btnEl.id) as HTMLButtonElement;

            btn?.addEventListener("click", function(e){
                e.preventDefault();

                // Init spin
                const spin = _that.btnSpin();
                
                // Set disabled attribute
                btn?.setAttribute('disabled', '');

                // Append spin to button
                btn?.append(spin);

                if(!btn.hasAttribute("data-section")){
                    
                    // Remove spin
                    spin.remove();
                        
                    // Remove the disabled attribute
                    btn.removeAttribute('disabled');
                    
                    return;
                    
                }

                if(!btn.hasAttribute("data-post")){
                    
                    // Remove spin
                    spin.remove();
                        
                    // Remove the disabled attribute
                    btn.removeAttribute('disabled');
                    
                    return;
                    
                }

                if(!btn.hasAttribute("data-page")){
                    
                    // Remove spin
                    spin.remove();
                        
                    // Remove the disabled attribute
                    btn.removeAttribute('disabled');
                    
                    return;
                    
                }

                // Section list comments
                const section = (typeof btn.dataset.section !== 'undefined') ? document.getElementById(btn.dataset.section) : null;
                
                // Post ID
                const post_id = btn.dataset.post;

                // Num page
                const num_page = btn.dataset.page;

                // Comment id
                const comment_id = (typeof btn.dataset.comment !== 'undefined') ? btn.dataset.comment : 0;

                // Data
                const data = {
                    "post_id": post_id,
                    'comment_id': comment_id,
                    "paged": num_page
                }; 

                // Conver form data to string
                const datastring = new URLSearchParams(data as any).toString();

                // Init post data
                const post_data = {
                    'fields': datastring
                };

                // Create query string
                const queryString = new URLSearchParams(post_data).toString();

                // Call ajax
                axios.post(_that.url_api_get_comments, queryString)
                    .then(function (response: any) {

                    // Remove spin
                    spin.remove();
                        
                    // Remove the disabled attribute
                    btn.removeAttribute('disabled');
                    
                    // Get status
                    const responseStatus: boolean = response.data.status;

                    if(responseStatus == true){
                        
                        // Current page
                        const current_page: number = response.data.current_page;

                        // Next page
                        const next_page: number = response.data.next_page;

                        // Last page
                        const last_page: number = response.data.last_page;

                        // Comments
                        const comments: string = response.data.comments;  

                        // Append new comments
                        section?.insertAdjacentHTML('beforeend', comments);

                        if(next_page === null){

                            btn.parentElement?.remove();
                            section?.classList.remove('load-reply-comments');

                        }else{
                            
                            // Set new page
                            btn.dataset.page = next_page.toString();

                            _that.loadComments();
                            
                        }

                    }

                })
                .catch(function (error:any){

                    const message = core_object.error_messages.general;
                    
                });

            });

        });
    
    }

    /**
     * Create spin
     * @returns 
     */
    protected btnSpin() {
        
        const elSpin = document.getElementById(this.elFormSpin) as HTMLElement;

        if(elSpin != null){
            
            return elSpin;
        
        }
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

}